module.exports = __webpack_public_path__ + "img/mobile-banner3.ef02436c.png";